import React, { useEffect, useRef } from 'react';
import { ScreentimeLimitPage as ScreentimeLimitPageWebApp } from 'Roblox';

function ScreentimeLimitPageLoader(): JSX.Element {
  const entryPointRef = useRef<HTMLDivElement | null>(null);

  // Render ScreentimeLimitPage webapp on mount.
  useEffect(() => {
    if (!entryPointRef.current) {
      throw new Error('Failed to find entry point element for ScreentimeLimitPageLoader.');
    }
    ScreentimeLimitPageWebApp.renderComponent(entryPointRef.current);
  }, []);

  return <div ref={entryPointRef} />;
}

export default ScreentimeLimitPageLoader;
